import { lighten } from 'polished';
import styled from 'styled-components';

type Props = {
  size?: 's' | 'm' | 'l';
  color?: 'default' | 'primary' | 'secondary' | 'green';
  nowrap?: boolean;
};

export const Tag = styled.div<Props>`
  display: flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.radii.s};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  white-space: ${({ nowrap }) => (nowrap ? 'nowrap' : 'normal')};

  ${({ theme, size = 's' }) => {
    switch (size) {
      case 's':
        return {
          fontSize: theme.fontSizes.xxs,
          padding: `${theme.spaces.xs} ${theme.spaces.m}`,
        };
      case 'm':
        return {
          fontSize: theme.fontSizes.xs,
          padding: `${theme.spaces.s} ${theme.spaces.m}`,
        };
      case 'l':
        return {
          fontSize: theme.fontSizes.s,
          padding: `${theme.spaces.s} ${theme.spaces.m}`,
        };
    }
  }}

  ${({ theme, color = 'default' }) => {
    switch (color) {
      case 'default':
        return {
          color: theme.fontColors.default,
          backgroundColor: lighten(0.4, theme.backgroundColors.lightgrey),
        };
      case 'primary':
        return {
          color: theme.fontColors.white,
          backgroundColor: theme.backgroundColors.primary,
        };
      case 'secondary':
        return {
          color: theme.fontColors.white,
          backgroundColor: theme.backgroundColors.secondary,
        };
      case 'green':
        return {
          color: theme.fontColors.white,
          backgroundColor: theme.backgroundColors.green,
        };
    }
  }}
`;
